var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-3" },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex align-items-center justify-content-between gap-2 mb-2",
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-sm btn-outline-secondary",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$router.back()
                },
              },
            },
            [
              _c("i", { staticClass: "fa fa-arrow-left me-1" }),
              _vm._v("\n            Kembali\n        "),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.loadingPage
        ? _c("div", { staticClass: "text-center py-5" }, [
            _c("div", { staticClass: "spinner-border text-primary" }),
            _vm._v(" "),
            _c("div", { staticClass: "mt-2 text-muted" }, [
              _vm._v("Memuat data pasien..."),
            ]),
          ])
        : _vm.errorPage
        ? _c("div", { staticClass: "alert alert-danger" }, [
            _c("div", { staticClass: "fw-semibold" }, [
              _vm._v("Data gagal dimuat"),
            ]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.errorPage))]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-sm btn-outline-danger mt-2",
                attrs: { type: "button" },
                on: { click: _vm.loadPage },
              },
              [
                _c("i", { staticClass: "fa fa-refresh me-1" }),
                _vm._v("\n            Muat Ulang\n        "),
              ]
            ),
          ])
        : [
            _c("div", { staticClass: "card border-0 shadow-sm mb-3" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "card-body patient-card-body" }, [
                _c(
                  "div",
                  { staticClass: "patient-grid" },
                  _vm._l(_vm.patientInfo, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.label,
                        staticClass: "patient-item",
                        class: item.className || "",
                      },
                      [
                        _c("div", { staticClass: "patient-label" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(item.label) +
                              "\n                        "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "patient-value" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.showValue(item.value)) +
                              "\n                        "
                          ),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm._m(2),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row g-3 align-items-stretch workspace-row" },
              [
                _c("div", { staticClass: "col-12 col-xl-4" }, [
                  _c(
                    "div",
                    { staticClass: "card border-0 shadow-sm icd-card" },
                    [
                      _vm._m(3),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "card-body" },
                        [
                          _vm.loading.icd
                            ? _c("div", { staticClass: "loading-section" }, [
                                _c("i", {
                                  staticClass: "fa fa-spinner fa-spin me-1",
                                }),
                                _vm._v(
                                  "\n                            Memuat ICD...\n                        "
                                ),
                              ])
                            : [
                                _c(
                                  "div",
                                  {
                                    staticClass: "alert alert-info py-2 small",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                Baris pertama merupakan diagnosis utama.\n                                Baris berikutnya merupakan diagnosis atau\n                                prosedur sekunder.\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm._l(_vm.icdRows, function (row, index) {
                                  return _c(
                                    "div",
                                    { key: row.key, staticClass: "icd-row" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "d-flex align-items-center justify-content-between gap-2 mb-2",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "badge",
                                              class:
                                                index === 0
                                                  ? "bg-primary"
                                                  : "bg-secondary",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    index === 0
                                                      ? "Diagnosis Utama"
                                                      : `Sekunder ${index}`
                                                  ) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-sm btn-outline-danger",
                                              attrs: {
                                                type: "button",
                                                disabled: _vm.savingIcd,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeIcdRow(index)
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "fa fa-trash",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "mb-3" },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "form-label small fw-semibold",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        ICD-10\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("v-select", {
                                            attrs: {
                                              options: _vm.icd10Options,
                                              clearable: true,
                                              filterable: false,
                                              label: "name",
                                              placeholder:
                                                "Ketik kode atau diagnosis ICD-10...",
                                            },
                                            on: {
                                              search: _vm.searchIcd10,
                                              input: function ($event) {
                                                return _vm.setIcd10(
                                                  $event,
                                                  index
                                                )
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "no-options",
                                                  fn: function () {
                                                    return [
                                                      _vm._v(
                                                        "\n                                            Ketik minimal 1 karakter\n                                        "
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value: row.diagnosa,
                                              callback: function ($$v) {
                                                _vm.$set(row, "diagnosa", $$v)
                                              },
                                              expression: "row.diagnosa",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "form-label small fw-semibold",
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        ICD-9\n                                    "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("v-select", {
                                            attrs: {
                                              options: _vm.icd9Options,
                                              clearable: true,
                                              filterable: false,
                                              label: "name",
                                              placeholder:
                                                "Ketik kode atau tindakan ICD-9...",
                                            },
                                            on: {
                                              search: _vm.searchIcd9,
                                              input: function ($event) {
                                                return _vm.setIcd9(
                                                  $event,
                                                  index
                                                )
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "no-options",
                                                  fn: function () {
                                                    return [
                                                      _vm._v(
                                                        "\n                                            Ketik minimal 1 karakter\n                                        "
                                                      ),
                                                    ]
                                                  },
                                                  proxy: true,
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                            model: {
                                              value: row.procedure,
                                              callback: function ($$v) {
                                                _vm.$set(row, "procedure", $$v)
                                              },
                                              expression: "row.procedure",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-outline-primary btn-sm w-100 mb-2",
                                    attrs: {
                                      type: "button",
                                      disabled: _vm.savingIcd,
                                    },
                                    on: { click: _vm.addIcdRow },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-plus-circle me-1",
                                    }),
                                    _vm._v(
                                      "\n                                Tambah Diagnosis\n                            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-success btn-sm w-100",
                                    attrs: {
                                      type: "button",
                                      disabled: _vm.savingIcd,
                                    },
                                    on: { click: _vm.saveIcd },
                                  },
                                  [
                                    _vm.savingIcd
                                      ? _c("span", {
                                          staticClass:
                                            "spinner-border spinner-border-sm me-1",
                                        })
                                      : _c("i", {
                                          staticClass: "fa fa-save me-1",
                                        }),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.savingIcd
                                            ? "Menyimpan..."
                                            : "Simpan ICD"
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ],
                        ],
                        2
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-xl-8" }, [
                  _c(
                    "div",
                    { staticClass: "card border-0 shadow-sm history-card" },
                    [
                      _vm._m(4),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "card-body history-scroll bg-body-tertiary",
                        },
                        [
                          _vm.Regno
                            ? _c("RiwayatPelayananIcd", {
                                key: _vm.Regno,
                                attrs: {
                                  regno: _vm.Regno,
                                  medrec: _vm.pasien.Medrec,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h3", { staticClass: "mb-0" }, [
        _vm._v(
          "\n                Detail CPPT dan Pengisian ICD Rawat Jalan / IGD\n            "
        ),
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "text-muted" }, [
        _vm._v(
          "\n                Riwayat pasien berdasarkan satu nomor registrasi\n            "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "card-header bg-primary text-white fw-semibold" },
      [
        _c("i", { staticClass: "fa fa-user me-1" }),
        _vm._v("\n                Data Pasien\n            "),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "patient-status" }, [
      _c("span", { staticClass: "badge bg-info text-dark" }, [
        _vm._v(
          "\n                        Rawat Jalan / IGD\n                    "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "card-header bg-primary text-white fw-semibold" },
      [
        _c("i", { staticClass: "fa fa-pencil-square-o me-1" }),
        _vm._v(
          "\n                        Pengisian ICD-10 dan ICD-9\n                    "
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header bg-white fw-semibold" }, [
      _c("i", { staticClass: "fa fa-folder-open text-success me-1" }),
      _vm._v(
        "\n                        Riwayat Pelayanan\n                    "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }